import { useEffect, useState } from "react";
import { fetchActiveSocialLinks } from "../api/socialLinksApi";
import { getSocialIcon } from "../utils/socialIcons";

export default function SocialSection() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const data = await fetchActiveSocialLinks();
        if (on) setLinks(Array.isArray(data) ? data : []);
      } catch {
        if (on) setLinks([]);
      }
    })();
    return () => {
      on = false;
    };
  }, []);

  if (!links.length) return null;

  return (
    <section className="cl-social-section">
      <div className="cl-container">
        <p className="cl-eyebrow center">Stay connected</p>
        <h2 className="cl-title center">Follow Click Law</h2>
        <p className="cl-social-sub">
          Updates, legal insights, and news from across our channels.
        </p>
        <div className="cl-social-row">
          {links.map((item) => {
            const Icon = getSocialIcon(item.platform);
            return (
              <a
                key={item.id}
                className="cl-social-chip"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label || item.platform}
              >
                <Icon />
                <span>{item.label || item.platform}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
